import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FakeBankGateway: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      // Pass 'newListingCreated' state to show success message on dashboard
      navigate('/dashboard', { 
        replace: true, 
        state: { newListingCreated: true } 
      });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-10 rounded-xl shadow-xl text-center max-w-md w-full">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
           <svg className="w-8 h-8 animate-spin" fill="none" viewBox="0 0 24 24">
             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
           </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">در حال انتقال به بانک...</h2>
        <p className="text-gray-500 mb-6">لطفاً از بستن این صفحه خودداری کنید.</p>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 text-sm font-mono text-gray-600">
           SHAPARAK MOCK GATEWAY
        </div>
      </div>
    </div>
  );
};

export default FakeBankGateway;